<template>
	<AppLayout :title="trans('tools.campaigns.title')">
		<template #actions>
			<PrimaryButton :color="Color.Green" @click.stop="showModal('create-campaign-modal')">
				<i class="fa-solid fa-plus mr-2"/>
				{{ trans('general.create') }}
			</PrimaryButton>
		</template>
		<Modal id="create-campaign-modal">
			<template #title>{{ trans('tools.campaigns.new.title') }}</template>
			<LabeledObject>
				<template #label>{{ trans('tools.campaigns.subject') }}</template>
				<input v-model="form.subject" type="text" maxlength="255">
			</LabeledObject>
			<template #footer>
				<PrimaryButton :color="Color.Green" @click.stop="create">
					<i class="fa-solid fa-check mr-2"/>
					{{ trans('general.confirm') }}
				</PrimaryButton>
			</template>
		</Modal>
		<Pagination :resource="campaigns"/>
		<Empty v-if="campaigns.data.length === 0"/>
		<CardGrid v-else>
			<Card v-for="campaign in campaigns.data" :key="`campaign-${campaign.id}`" :title="campaign.subject" :subtitle="dayjs(campaign.updated_at).format(trans('general.dayjs.datetime'))">
				<template #footer>
					<Link :as="SecondaryButton" :color="Color.Blue" :href="route('tools.campaigns.edit', campaign.id)">
						<i class="fa-solid fa-edit mr-2"/>
						{{ trans('general.edit') }}
					</Link>
				</template>
			</Card>
		</CardGrid>
		<Pagination :resource="campaigns"/>
	</AppLayout>
</template>
<script setup lang="ts">
import dayjs from 'dayjs'
import {route} from 'ziggy-js'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import Empty from '@/Components/UI/Empty.vue'
import {defineProps, type Ref, ref} from 'vue'
import Card from '@/Components/UI/Cards/Card.vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import Modal from '@/Components/UI/Modals/Modal.vue'
import Pagination from '@/Components/UI/Pagination.vue'
import CardGrid from '@/Components/UI/Cards/CardGrid.vue'
import LabeledObject from '@/Components/UI/LabeledObject.vue'
import {type Campaign} from '@/Types/Tools/Campaigns/Campaign'
import {type InertiaForm, Link, useForm} from '@inertiajs/vue3'
import PrimaryButton from '@/Components/UI/Buttons/PrimaryButton.vue'
import {type PaginatedModel} from '@/Types/Pagination/PaginatedModel'
import SecondaryButton from '@/Components/UI/Buttons/SecondaryButton.vue'
import {showInfo, showModal, showSuccess, showValidationErrors} from '@/Helpers/general'

const props = defineProps<{
	campaigns:PaginatedModel<Campaign>,
}>()

const working:Ref<boolean> = ref(false)
const campaigns:Ref<PaginatedModel<Campaign>> = ref(props.campaigns)
const form:InertiaForm<Campaign> = useForm<Campaign>({
	subject: '',
} as Campaign)

function create():void{
	if(!working.value){
		working.value = true
		showInfo(trans('general.inserting'))
		form.post(route('tools.campaigns.store'), {
			onSuccess: () => {
				showSuccess(trans('general.inserted'))
			},
			onError: showValidationErrors,
			onFinish: () => {
				working.value = false
			},
		})
	}
}
</script>